
import React, { useState, useEffect, useCallback } from "react";
import cn from "classnames";
import { Link, useLocation } from "react-router-dom";
import styles from "./Navigation.module.scss";
import authService from "services/auth.service";
import LocalStorageService from "services/tokenlocalstorage.service";
import tokenlocalstorageService from "services/tokenlocalstorage.service";
import notificationService from "services/notification.service";
import {
  postRequestInService as postRequest,
  getRequestInService as getRequest,
} from "services/axiosServiceBaseClient";
import { getRequestInFileDownload } from "services/axiosFileDownloadService";
import jwtDecode from "jwt-decode";
import axios from "axios";

const titleCase = (title) =>
  title
    ?.split(/ /g)
    .map((word) => `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`)
    .join(" ");

var navAdmin = {
  id: 1,
  username: titleCase(authService.getUserName()),
  pageGroups: [
    {
      id: 3_1,
      pageGroupName: "Main",
      pageLinks: [
        {
          id: 3_3_1,
          pageName: "Dashboard",
          img: require("assets/home_black.svg").default,
          link: "/Dashboard",
        },
        {
          id: 3_3_2,
          pageName: "Tracking",
          img: require("assets/track.svg").default,
          link: "/Tracking",
        },
        {
          id: 3_3_3,
          pageName: "Swapping",
          img: require("assets/Swapping.png").default,
          link: "/Swapping",
        },
        {
          id: 3_3_3,
          pageName: "Invoice",
          img: require("assets/invoice 1.png").default,
          link: "/Invoice",
        },
        {
          id: 3_3_3,
          pageName: "Reports",
          img: require("assets/repor 1(2).png").default,
          link: "/Reports",
        },
        {
          id: 3_3_3,
          pageName: "Alerts",
          img: require("assets/alert.png").default,
          link: "/Alerts",
        },
      ],
    },
    {
      id: 3_2,
      pageGroupName: "Status",
      pageLinks: [
        {
          id: 3_3_4,
          pageName: "Sites",
          img: require("assets/sites.png").default,
          link: "/sites",
        },

        {
          id: 3_3_5,
          pageName: "SwapStation",
          img: require("assets/swapstation.png").default,
          link: "/SwapStation",
        },
        {
          id: 3_3_6,
          pageName: "Batteries",
          img: require("assets/batteries.png").default,
          link: "/batteries",
        },
      ],
    },
    {
      id: 3_3,
      pageGroupName: "Operations",
      pageLinks: [
        {
          id: 3_3_1,
          pageName: "Schedule",
          img: require("assets/Sechdule.png").default,
          link: "/Schedule",
        },
        {
          id: 3_3_2,
          pageName: "ServiceRequest",
          img: require("assets/ServiceListing.png").default,
          link: "/ServiceRequest",
        },
      ],
    },
    {
      id: 3_4,
      pageGroupName: "Configuration",
      pageLinks: [
        {
          id: 3_3_1,
          pageName: "Users",
          img: require("assets/Users.svg").default,
          link: "/Users",
        },
        {
          id: 3_3_2,
          pageName: "Assets",
          // img: require("assets/assets.svg").default,
          img: require("assets/flower.svg").default,
          link: "/Assets",
        },
        {
          id: 3_3_3,
          pageName: "Pricing",
          img: require("assets/pricing.png").default,
          link: "/Pricing",
        },
        {
          id: 3_3_4,
          pageName: "FOTA",
          img: require("assets/Swap_me.svg").default,
          link: "/Fota",
        },
      ],
    },
  ],
};

var navOperator = {
  id: 1,
  username: titleCase(authService.getUserName()),
  pageGroups: [
    {
      id: 3_1,
      pageGroupName: "Main",
      pageLinks: [
        {
          id: 3_3_1,
          pageName: "Dashboard",
          img: require("assets/Dashboard.png").default,
          link: "/Dashboard",
        },
        {
          id: 3_3_2,
          pageName: "Tracking",
          img: require("assets/track.svg").default,
          link: "/Tracking",
        },
        {
          id: 3_3_3,
          pageName: "Swapping",
          img: require("assets/Swapping.png").default,
          link: "/Swapping",
        },
        {
          id: 3_3_3,
          pageName: "Invoice",
          img: require("assets/invoice 1.png").default,
          link: "/Invoice",
        },
        {
          
          id: 3_3_3,
          pageName: "Reports",
          img: require("assets/repor 1(2).png").default,
          link: "/Reports",
        },
        
        {
          id: 3_3_3,
          pageName: "Alerts",
          img: require("assets/alert.png").default,
          link: "/Alerts",
        },
      ],
    },
    {
      id: 3_2,
      pageGroupName: "Status",
      pageLinks: [
        {
          id: 3_3_4,
          pageName: "Sites",
          img: require("assets/sites.png").default,
          link: "/sites",
        },
        {
          id: 3_3_5,
          pageName: "SwapStation",
          img: require("assets/swapstation.png").default,
          link: "/SwapStation",
        },
        {
          id: 3_3_6,
          pageName: "Batteries",
          img: require("assets/batteries.png").default,
          link: "/batteries",
        },
      ],
    },
    {
      id: 3_3,
      pageGroupName: "Operations",
      pageLinks: [
        {
          id: 3_3_1,
          pageName: "Schedule",
          img: require("assets/Sechdule.png").default,
          link: "/Schedule",
        },
        {
          id: 3_3_2,
          pageName: "ServiceRequest",
          img: require("assets/ServiceListing.png").default,
          link: "/ServiceRequest",
        },
      ],
    },
    {
      id: 3_4,
      pageGroupName: "Configuration",
      pageLinks: [
        {
          id: 3_3_2,
          pageName: "Assets",
          // img: require("assets/asset.svg").default,
          img: require("assets/flower.svg").default,
          
          link: "/Assets",
        },
        {
          id: 3_3_3,
          pageName: "Pricing",
          img: require("assets/pricing.png").default,
          link: "/Pricing",
        },
      ],
    },
  ],
};

var testingOne = "amhitted"
var tabTemp="inactive"
var navTemp = "single"

export default function Navigation(props) {
  const { pathname } = useLocation();
  const splitLocation = pathname.split("/");
  const [userRole, setUserRole] = useState("");
  const [nav, setNav] = useState(navOperator);
  const [choosenFileName, setChoosenFileName] = useState("No file Choosen");
  const [image, setImage] = useState([]);
  const [email, setEmail] = useState("");
  const [enterpriseName, setEnterpriseName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [profilePicture, setProfilePicture] = useState("");
  const [imgData, setImgData] = useState(null);
  const [imgUrl, setImgUrl] = useState("");
  const [data, setData] = useState([]);
  const [name, setName] = useState("")
  const [enterpriseUser, setEnterpriseUSer] = useState("");
  var fileLocation = "";

  const initialFormValues = {
    profilePicture: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const arrayBufferToBase64q = useCallback((buffer) => {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  });
  // function bin2String(array) {
  //   var result = "";
  //   for (var i = 0; i < array.length; i++) {
  //     result += String.fromCharCode(parseInt(array[i], 2));
  //   }
  //   return result;
  // }

  const downloadProfilePicture = useCallback(async (enterprise, imgPath) => {
   
   const encodeImgPath= encodeURIComponent(imgPath)
    await getRequestInFileDownload(
      `downloadFile/${enterprise}?fileName=${encodeImgPath}` //${imgPath}  ${enterprise}
      ).then((res) => {
      if (res) {
        setData(res);
        if (res) {
          props.setImage(res);
          tokenlocalstorageService.setProfileImage(res);
        }
      }
    });
  });

  const editEventHandle = () => {
    document.getElementById("img-update").click();
  };

  const avatarUpdateHandle = (event, email) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      var size = parseFloat(img.size / (1024 * 1024)).toFixed(2); 
      if(size > 2) {
          notificationService.showNonBlacklistedError("", "Please select image size less than 2 MB.");
        return false
      }

      setChoosenFileName(img.name);
      var imgvar = "";
      imgvar = img;
      setImage(imgvar);
      var token = LocalStorageService.get("token");
      var decode = jwtDecode(token);
      var email = decode.email;
      setEmail(email);
      // console.log(profilePicture, '.............PROFILE PICTURE')

      if (userRole === "admin") {
        const formData = new FormData();
        formData.append("file", imgvar);

        // const updateAdminProfilePicture = (email)=>{
        postRequest("bss/svc/admin/image-upload", formData).then(
          (res) => {
            if (res.status === 200) {
              // getUserDetail();
              // console.log('<<<<<<<<Success>>>>>>>')
              getUserDetail();
            }
          }
        );
        // };
      } else {
        // There add the API for update opertator image upload
        // const updateOperatorProfilePicture = async (email)=>{
        const formData = new FormData();
        formData.append("file", imgvar);

        postRequest(
          "bss/svc/operator/image-upload",
          formData
        ).then((res) => {
          if (res.status === 200) {
            getUserDetail();
          }
        });
        // };
      }

      // changeProfilePicture(enterpriseName, profilePicture);
    }
  };

  const getUserDetail = useCallback(async () => {
    const token = tokenlocalstorageService.getLocalAccessToken();
    // console.log(token, 'TOKEN')
    var decode = jwtDecode(token);

    // setUserEmail(decode.email)
    const userRole = LocalStorageService.get("user-role");
    let currentRole = "";
    let email = "";
    email = decode.email;
    userRole.toLocaleLowerCase() === "admin"
      ? (currentRole = "admin")
      : (currentRole = "operator");
    await getRequest(
      "bss/svc/" + currentRole+"/info"
    ).then((res) => {
      if (res && res?.data) {
        var temp = res?.data;
        // console.log(temp.imagePath, temp.enterpriseName, '<><><><><><>')
        setProfilePicture(temp?.imagePath);
        setEnterpriseName(temp?.enterpriseName);
        LocalStorageService.set("nameUser", temp?.username);
        downloadProfilePicture(temp?.enterpriseName, temp?.imagePath);
      }
    });
  }, []);

  // const fetchImg = async () => {
  //   const res = await fetch(imgData);
  //   const imageBlob = await res.blob();
  //   const reader = new FileReader();
  //   reader.readAsDataURL(imageBlob);
  //   const imageObjectURL = URL.createObjectURL(imageBlob);
  //   reader.onloadend = () => {
  //     const base64data = reader.result;
  //     setImgUrl(base64data);
  //   };
  //   console.log(imageObjectURL, "<<<<<IMAGE OBJECT URL>>>>>>>");
  //   setImage(imageObjectURL);
  // };


  // function getBase64(url) {
  //   return axios
  //     .get(url, {
  //       responseType: "arraybuffer",
  //     })
  //     .then((response) =>
  //       Buffer.from(response.data, "binary").toString("base64")
  //     );
  // }

  // const fetchImg = async()=>{
  //   fetch(imgData).then(response => response.json()).then(data=>{
  //     console.log(data, '<><><><><><><><><><>')
  //   })
  // }

  // useEffect(()=>{
  //   fetchImg();
  // },[])

  useEffect(() => {
    const img = tokenlocalstorageService.getProfileImage();
    if (img) {
      setData(img);
      props.setImage(img);
    } else {
      getUserDetail();
    }
    //changeProfilePicture(enterpriseName, profilePicture);
    setUserRole(LocalStorageService.get("user-role"));
    var role = LocalStorageService.get("user-role")
    role.toLocaleLowerCase() === "admin"
      ? setNav(navAdmin)
      : setNav(navOperator);
  }, []);

  const handleTest = (link) => {
    testingOne = "amhitted"
    link == "/Assets"
      ? localStorage.setItem("activeTabCount", "zoneAsset")
      : localStorage.setItem("activeTabCount", "other");
      localStorage.setItem("lastTableSearch", "")
  }

  useEffect(()=>{
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // return ()=>{
    //   localStorage.setItem("activeTabCount", "other");
    // }
  },[])
  return (
    <div id={"nav_main"} className={`Navigation ${cn(styles.block23, styles.block23_layout1)}`}>
      <div id={"nav_main_menu"} className={cn(styles.block35, styles.block35_layout)}>
        {nav.pageGroups[0].pageLinks.map((element, i) => {
          return (
            <Link id={element.pageName+"_link"}  to={{
              pathname:  element.link,
              state:{
                compomentRenderType: "amhitted" 
              }
            }}
            
            >
              <div id={element.pageName+"_box"}
                className={cn(styles.block40, styles.block40_layout)}
                // onClick={() => alert("It is clickable")}
                key={i}
              >
                <div id={element.pageName+"_div"} className={cn(styles.link)}>
                  <div id={element.pageName+"_text"}
                    className={
                      splitLocation[1] === element.pageName.replace(/ /g, "")
                        ? cn(
                            styles.text_body_selected,
                            styles.text_body_selected_layout
                          )
                        : cn(styles.text_body6, styles.text_body6_layout)
                    }
                    onClick={() => handleTest(element.link)}
                    style={!props.navOpen ? { display: "none" } : {}}
                  >
                    {element.pageName} 
                  </div>

                  <div id={element.pageName+"_icon"}
                    style={{
                      "--src": `url(${element.img})`,
                      "--height": `${props.navOpen ? "20px" : "25px"}`,
                      "--width": `${props.navOpen ? "20px" : "25px"}`,
                    }}
                    onClick={() => handleTest(element.link)}
                    className={cn(
                      styles.box24,
                      splitLocation[1].toLowerCase() ===
                        element.pageName.toLowerCase()
                        ? styles.box24_layout_selected
                        : styles.box24_layout
                    )}
                  />
                </div>
              </div>
            </Link>
          );
        })}

        <div id={"group_div_"+nav.pageGroups[0].pageGroupName} className={cn(styles.flex10, styles.flex10_layout)}>
          <div id={"group_"+ nav.pageGroups[0].pageGroupName+"_text"}
            className={cn(styles.text_body5, styles.text_body5_layout)}
            style={!props.navOpen ? { display: "none" } : {}}
          >
            {nav.pageGroups[0].pageGroupName}
          </div>
          <hr className={cn(styles.line3, styles.line3_layout)} />
        </div>
      </div>

      <div id={"nav_element"} className={cn(styles.block35, styles.block35_layout)}>
        {nav.pageGroups[1].pageLinks.map((element, i) => {
          return (
            <Link id={element.pageName+"_link"}  to={element.link}>
              <div id={element.pageName+"_box"} 
                className={cn(styles.block40, styles.block40_layout)}
                // onClick={() => alert("It is clickable")}
                key={i}
              >
                <div id={element.pageName+"_div"} className={cn(styles.link)}>
                  <div id={element.pageName+"_text"}
                    className={
                      splitLocation[1].toLowerCase() ===
                      element.pageName.toLowerCase()
                        ? cn(
                            styles.text_body_selected,
                            styles.text_body_selected_layout
                          )
                        : cn(styles.text_body6, styles.text_body6_layout)
                    }
                    style={!props.navOpen ? { display: "none" } : {}}
                    onClick={() => handleTest(element.link)}
                  >
                    {element.pageName.replace("SwapStation", "Swap Station")}
                  </div>

                  <div
                    id={element.pageName+"_icon"}
                    style={{
                      "--src": `url(${element.img})`,
                      "--height": `${props.navOpen ? "20px" : "25px"}`,
                      "--width": `${props.navOpen ? "20px" : "25px"}`,
                    }}
                    onClick={() => handleTest(element.link)}
                    className={cn(
                      styles.box24,
                      splitLocation[1].toLowerCase() ===
                        element.pageName.toLowerCase()
                        ? styles.box24_layout_selected
                        : styles.box24_layout
                    )}
                  />
                </div>
              </div>
            </Link>
          );
        })}

        <div id={"group_div_"+nav.pageGroups[1].pageGroupName} className={cn(styles.flex10, styles.flex10_layout)}>
          <div id={"group_"+ nav.pageGroups[1].pageGroupName+"_text"}
            className={cn(styles.text_body5, styles.text_body5_layout)}
            style={!props.navOpen ? { display: "none" } : {}}
          >
            {/* {"Page Group2"} */}
            {nav.pageGroups[1].pageGroupName}
            {/* {props.pageGroup} */}
          </div>
          <hr className={cn(styles.line3, styles.line3_layout)} />
        </div>
      </div>
      <div id={"nav_element"} className={cn(styles.block35, styles.block35_layout)}>
        {nav.pageGroups[2].pageLinks.map((element, i) => {
          return (
            <Link id={element.pageName+"_link"} to={{pathname :element.link, state:{
              compomentRenderType: "amhitted" 
            }}}>
              <div id={element.pageName+"_box"}
                className={cn(styles.block40, styles.block40_layout)}
                // onClick={() => alert("It is clickable")}
                key={i}
              >
                <div id={element.pageName+"_div"} className={cn(styles.link)}>
                  <div id={element.pageName+"_text"}
                    className={
                      splitLocation[1].toLowerCase() ===
                      element.pageName.toLowerCase()
                        ? cn(
                            styles.text_body_selected,
                            styles.text_body_selected_layout
                          )
                        : cn(styles.text_body6, styles.text_body6_layout)
                    }
                    onClick={() => handleTest(element.link)}
                    style={!props.navOpen ? { display: "none" } : {}}
                  >
                    {element.pageName.replace(
                      "ServiceRequest",
                      "Service Request"
                    )}
                  </div>

                  <div id={element.pageName+"_icon"}
                    style={{
                      "--src": `url(${element.img})`,
                      "--height": `${props.navOpen ? "20px" : "25px"}`,
                      "--width": `${props.navOpen ? "20px" : "25px"}`,
                    }}
                    onClick={() => handleTest(element.link)}
                    className={cn(
                      styles.box24,
                      splitLocation[1].toLowerCase() ===
                        element.pageName.toLowerCase()
                        ? styles.box24_layout_selected
                        : styles.box24_layout
                    )}
                  />
                </div>
              </div>
            </Link>
          );
        })}

        <div id={"group_div_"+nav.pageGroups[2].pageGroupName} className={cn(styles.flex10, styles.flex10_layout)}>
          <div id={"group_"+ nav.pageGroups[2].pageGroupName+"_text"}
            className={cn(styles.text_body5, styles.text_body5_layout)}
            style={!props.navOpen ? { display: "none" } : {}}
          >
            {/* {"Page Group2"} */}
            {nav.pageGroups[2].pageGroupName}
            {/* {props.pageGroup} */}
          </div>
          <hr className={cn(styles.line3, styles.line3_layout)} />
        </div>
      </div>
      <div id={"nav_element"} className={cn(styles.block35, styles.block35_layout)}>
        {nav.pageGroups[3].pageLinks.map((element, i) => {
          return (
            <Link  id={element.pageName+"_link"} 
              to={{
                pathname: element.link,
                navTemp: navTemp,
                compomentRenderType: "amhitted",
                tabTemp: tabTemp,
              }}
            >
              <div id={element.pageName+"_box"}
                className={cn(styles.block40, styles.block40_layout)}
                key={i}
              >
                <div id={element.pageName+"_div"} className={cn(styles.link)} >
                  <div id={element.pageName+"_text"}
                    className={
                      splitLocation[1].toLowerCase() ===
                      element.pageName.toLowerCase()
                        ? cn(
                            styles.text_body_selected,
                            styles.text_body_selected_layout
                          )
                        : cn(styles.text_body6, styles.text_body6_layout)
                    }
                    style={!props.navOpen ? { display: "none" } : {}}
                    onClick={() => handleTest(element.link)}
                  >
                    {element.pageName}
                  </div>

                  <div id={element.pageName+"_icon"}
                    style={{
                      "--src": `url(${element.img})`,
                      "--height": `${props.navOpen ? "20px" : "25px"}`,
                      "--width": `${props.navOpen ? "20px" : "25px"}`,
                    }}
                    onClick={() => handleTest(element.link)}
                    className={cn(
                      styles.box24,
                      splitLocation[1].toLowerCase() ===
                        element.pageName.toLowerCase()
                        ? styles.box24_layout_selected
                        : styles.box24_layout
                    )}
                  />
                </div>
              </div>
            </Link>
          );
        })}

        <div id={"group_div_"+nav.pageGroups[3].pageGroupName} className={cn(styles.flex10, styles.flex10_layout)}>
          <div id={"group_"+ nav.pageGroups[3].pageGroupName+"_text"}
            className={cn(styles.text_body5, styles.text_body5_layout)}
            style={!props.navOpen ? { display: "none" } : {}}
          >
            {/* {"Page Group2"} */}
            {nav.pageGroups[3].pageGroupName}
            {/* {props.pageGroup} */}
          </div>
          <hr className={cn(styles.line3, styles.line3_layout)} />
        </div>
      </div>

      {props.navOpen ? (
        <div className={cn(styles.block41, styles.block41_layout)}>
          <h5 className={cn(styles.highlights2, styles.highlights2_layout)}>
            {/* {"User name"} */}
            { props?.enterpriseUser }
            {/* {nav.username} */}
            {/* <Navigation username = {nav.username} /> */}
          </h5>
        </div>
      ) : (
        <></>
      )}

      <div className={cn(styles.box27, styles.box27_layout)}>
        <Link to="/UserProfile">
          <img
            src={
              !data || data?.length == 0
                ? require("assets/profile.png").default
                : "data:image/png;base64, " + data
            }
            alt={require("assets/profile.png").default}
            style={{
              borderRadius: "100%",
              width: "70px",
              height: "70px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </Link>
      </div>

      <div className={cn(styles.avtar_edit_container)}>
        <img
          src={require("assets/Edit.svg").default}
          className={cn(styles.avtar_edit_icon)}
          onClick={editEventHandle}
        />
      </div>
      <input
        type="file"
        name="fileLocation"
        id="img-update"
        accept="image/jpeg, image/png"
        onChange={avatarUpdateHandle}
        style={{ display: "none" }}
        className={cn(styles.avatar_upload_btn)}
        onClick={(event)=> { 
          const { target = {} } = event || {};
          target.value = "";
        }}
      />
    </div>
  );
}

Navigation.inStorybook = true;
